import { assocPath } from "ramda";
import { ideaConverter } from "./converter";

export const getIdea = (id) => (dispatch, getState, { api }) =>
  api.get(`/private/idea/idea/${id}`)
    .then((response) => {
      return assocPath(['data'], ideaConverter.forFE(response.data), response);
    });
